export const FilterSeparator = () => {
    return <div className="mx-5 h-7.5 border-l border-gray-300"></div>;
};
